import Questions from 'scenes/Questions'
import withPreloadedQuery from 'withPreloadedQuery'
import { isAllowed, QuestionsQuery } from 'scenes/Questions/Questions'
import { serverSidePostQueryAuth } from 'services/auth'
import { Questions_Query } from '__generated__/Questions_Query.graphql'

export default withPreloadedQuery(Questions, QuestionsQuery, {
  variablesFromContext(ctx) {
    const category = Array.isArray(ctx.query.category) ? ctx.query.category?.[0] : ctx.query.category
    return {
      slug: category || '',
      hasCategory: Boolean(category),
    }
  },
  serverSidePostQuery: serverSidePostQueryAuth<Questions_Query>(
    queryResult => isAllowed(queryResult?.data?.currentUser),
  ),
})
